// extracted by css-extract-rspack-plugin
export default {"TimeseriesGroup":"TimeseriesGroup--nhXLz","TimeseriesContainer":"TimeseriesContainer--T3OaH"};